import { render, staticRenderFns } from "./Resync.vue?vue&type=template&id=48bdf970&scoped=true"
var script = {}
import style0 from "./Resync.vue?vue&type=style&index=0&id=48bdf970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdf970",
  null
  
)

export default component.exports